import { AssetAlignmentDirection, AssetAlignmentType } from 'const';
import { AssetAlignmentMap } from 'models';

export const ASSET_ALIGNMENTS: {
  type: AssetAlignmentType;
  style: React.CSSProperties;
}[] = [
  {
    type: AssetAlignmentType.LEFT,
    style: { alignItems: 'flex-start' },
  },
  {
    type: AssetAlignmentType.HORIZONTAL_CENTER,
    style: { alignItems: 'center' },
  },
  {
    type: AssetAlignmentType.RIGHT,
    style: { alignItems: 'flex-end' },
  },
  {
    type: AssetAlignmentType.TOP,
    style: { justifyContent: 'flex-start' },
  },
  {
    type: AssetAlignmentType.VERTICAL_CENTER,
    style: { justifyContent: 'center' },
  },
  {
    type: AssetAlignmentType.BOTTOM,
    style: { justifyContent: 'flex-end' },
  },
];

export const getAlignment = (alignment: AssetAlignmentMap): React.CSSProperties => {
  if (!alignment) {
    return {};
  }

  return {
    ...ASSET_ALIGNMENTS.find(align => align.type === alignment.get(AssetAlignmentDirection.HORIZONTAL))?.style,
    ...ASSET_ALIGNMENTS.find(align => align.type === alignment.get(AssetAlignmentDirection.VERTICAL))?.style,
  };
};
